var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaIzquierda24X24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80829 12.2071C6.66384 12.3757 6.66384 12.6243 6.80829 12.7928L12.1389 19.0119C12.4085 19.3264 12.372 19.7999 12.0576 20.0694C11.7431 20.339 11.2696 20.3026 11 19.9881L5.6694 13.769C5.04347 13.0388 5.04347 11.9612 5.6694 11.2309L11 5.01189C11.2696 4.6974 11.7431 4.66098 12.0576 4.93054C12.372 5.20011 12.4085 5.67359 12.1389 5.98808L6.80829 12.2071Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31946 12.5C5.31946 12.9142 5.65524 13.25 6.06946 13.25H18.5695C18.9837 13.25 19.3195 12.9142 19.3195 12.5C19.3195 12.0858 18.9837 11.75 18.5695 11.75H6.06946C5.65524 11.75 5.31946 12.0858 5.31946 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaIzquierda24X24);
export default __webpack_public_path__ + "static/media/FLECHA_IZQUIERDA_24X24.03aecb15c25a7718606c724b2b9e2349.svg";
export { ForwardRef as ReactComponent };